export const SECTION_NAME_MAP = {
  campusSwiper: '校园招聘-轮播',
  campusRecruitmentTypes: '校园招聘-分类',
  campusRecruitmentEntries: '校园招聘-导航',
  competition: '美团赛事',
  beidou: '北斗计划',
  qihang: '零售启航计划',
  serviceList: '产品和服务',
  briefList: '美团简介',
  defaultWorkList: '工作在美团',
  socialQuestionList: '社招问题',
  campusQuestionList: '校招问题',
  announcementList: '公告',
  bgList: '事业部',
  moduleList: '了解美团-工作在美团',
  campusTvModuleList: '校招TV-板块列表',
  focusList: '关注我们',
  bannerList: '板块背景',
  bannerDesc: '板块介绍',
  campusSchedule: '校招行程',
  campusTarget: '校招行程-招聘对象',
  sendResumeTime: '校招行程-投递时间',
  writtenArrangement: '校招行程-笔试安排',
  beiDouProgram: '新北斗计划',
  campusAnnouncementTip: '校招投递提示',
};

/**
 * cms数据本地备份，勿删
 */
const cmsBackup = {
  globalConfig: {
    email: 'zhaopin@meituan.com',
  },
  sectionTypes: [
    {
      id: '116',
      sectionName: '校招行程',
      sections: [
        {
          id: '777823541731',
          title: '2025年春季校园招聘行程介绍',
          secondTitle: '2025年3月17日起陆续安排面试（以远程为主），请大家及时关注邮件、短信通知',
          linkText: '具体行程安排请关注“美团招聘”官方公众号及小红书号',
          date: '2025/02/26',
        },
      ],
    },
    {
      id: '117',
      sectionName: '校招行程-投递时间',
      sections: [
        {
          id: '777823541732',
          title: '简历投递时间',
          description:
            '<p>网申开始时间：2025年2月26日</p><p>网申截止时间：2025年5月31日（部分岗位招满后会提前结束网申）</p>',
        },
      ],
    },
    {
      id: '119',
      sectionName: '校招行程-笔试安排',
      sections: [
        {
          id: '777823541738',
          secondTitle: '笔试共安排9场',
          description:
            "<p>常规笔试共9场，通知会在考试前一天（周五）以短信、邮件的形式统一发放</p><p><br></p><p></p><p>3月31日24:00前投递2026届转正实习岗位的同学，在进入面试前拥有最多2次完成笔试的机会，笔试成绩取高值</p><p><br></p><p><span style='color: red'>*</span> 部分岗位包含AI面试；零售类、销售、客服和支持类部分岗位笔试即投即测，不设2次笔试机会，请仔细阅读邮件信息</p>",
          extra: ['120'],
        },
      ],
    },
    {
      id: '139',
      sectionName: '新北斗计划',
      sections: [
        {
          id: '777823541810',
          title: '<span style="font-size: 28px">北斗计划</span><br />面向全球招募精尖校园科技人才',
          secondTitle: '期待一起用科技造福亿万用户与商家，让科技走向烟火人间！',
          description: '<p>我们坚信，只有依靠高科技（尤其是AI技术），才能让全球百姓“吃得更好，生活更好”。</p>',
          linkUrl: '热招职位包括但不限于上述方向，欢迎点击链接了解详情',
          linkText: '长期有耐心地搞科研投入<br />而不是一味地追风口',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%96%B0%E5%8C%97%E6%96%97%E8%AE%A1%E5%88%92%2Fmobile_beidou_bg-1723115634240.png',
          extra: ['140', '141'],
        },
      ],
    },
    {
      id: '155',
      sectionName: '板块介绍',
      sections: [
        {
          id: '777823541953',
          title: '校园招聘',
          description:
            '<p>美团有多少年，校招就有多少年。美团创立之初，就开始招聘和培养应届生了，很多当年的应届生已经成长为业务骨干、团队负责人，成为美团的中流砥柱。目前，校园招聘设有应届生校招、转正实习、日常实习等招聘项目。无论你在哪个年级、学什么专业，都有机会来美团学习实践，和我们一起成长，一起更好！</p>',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/campustips/xiaozhao.png',
          code: 'campus',
        },
        {
          id: '777823541954',
          title: '社会招聘',
          description:
            '<p>社会招聘主要面向有一定工作经验的优秀人才。聚焦“零售 + 科技”战略，美团为优秀人才提供了更丰富的机会、更广阔的发展空间，欢迎大家与我们一起在多元的业务场景中学习实践，一起“帮大家吃得更好，生活更好”</p>',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/campustips/shezhao.png',
          code: 'social',
        },
        {
          id: '777823541955',
          title: '北斗计划',
          description:
            '<p>北斗计划是美团面向全球精尖校园科技人才的招聘项目，目标是基于美团多元的业务场景和广阔的职业平台，培养及储备能引领未来科技发展的技术专家，携手打造多层次科技服务平台。该项目自启动以来，吸引了海内外高校诸多优秀科技人才加入，经过多年的耕耘及沉淀，逐渐形成了助力专业人才成长和发展的项目体系。现诚邀各技术领域的优秀同学加入“北斗计划”，一起成长，一起更好，共同践行“帮大家吃得更好，生活更好”的使命！</p>',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/campustips/beidou.png',
          code: 'beidou',
        },
        {
          id: '777823541956',
          title: '零售启航计划',
          description:
            '<p>“零售启航计划”是美团为招募零售类校园人才成立的战略性专项计划，目标是培养及储备具有数字化思维的零售人才，和美团一起乘风破浪，扬帆启航。该项目涵盖丰富的岗位类型及多元的业务方向，通过3重系统化培养，助力同学们在美团的多元领域和广阔平台上，成长为零售序列的专家或管理者，共建美团未来的零售业务体系。</p><p>现诚邀各位同学加入美团零售启航计划，共同践行美团“帮大家吃得更好，生活更好”的使命！</p>',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/campustips/qihang.png',
          code: 'qihang',
        },
      ],
    },
    {
      id: '162',
      sectionName: '校招投递提示',
      sections: [
        {
          id: '777823541978',
          description:
            '<p>1.最多可投递3个职位，建议根据自己的兴趣和职位描述，尽量填满；</p><p>2.职位投递后，会按照志愿顺序流转，志愿不可修改，请谨慎选择；</p><p>3.你的毕业时间需要在此次校招的范围内，请关注；</p><p>4.美团关注候选人对AI的好奇与实践，欢迎大家使用AI编程平台NoCode（<a target="_blank" rel="noopener noreferrer nofollow" href="https://nocode.cn">nocode.cn</a>）创作产品或功能，期待在部分岗位的面试中与你交流！</p>',
        },
      ],
    },
    {
      id: '71',
      sectionName: '产品和服务',
      sections: [
        {
          id: '661816715535',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/meituan%402x.png',
          title: '美团',
          description:
            '<p>美团App是中国领先的综合生活服务平台。通过美团App，用户可以方便地享受到包括美食、外卖、酒店、旅游、电影、医美、商品零售等在内的一站式生活服务。</p>',
          linkUrl: '#',
          order: 0,
          isNotice: false,
        },
        {
          id: '563870263600',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/dianping%402x.png',
          title: '大众点评',
          description:
            '<p>大众点评是美团旗下的本地生活消费指南平台，覆盖吃喝玩乐游购娱等生活场景，致力于为消费者提供全面、可信的线上商户信息及消费评价，满足用户找店需求。</p>',
          linkUrl: '#',
          order: 1,
          isNotice: false,
        },
        {
          id: '701820754716',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/waimai%402x.png',
          title: '美团外卖',
          description:
            '<p>美团外卖2013年11月正式上线，秉承“帮大家吃得更好，生活更好”的使命，通过科技连接消费者和商家，依托庞大的骑手团队，搭建起了覆盖全国的实时配送网络，为消费者提供品质化、多样化的餐饮外卖服务。</p>',
          linkUrl: '#',
          order: 2,
          isNotice: false,
        },
        {
          id: '125851761236',
          icon: '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E4%BA%A7%E5%93%81%E5%92%8C%E6%9C%8D%E5%8A%A1%2Fshangou-1745754374865.png',
          title: '美团闪购',
          description:
            '<p>美团闪购是美团旗下的即时零售平台。依托美团大生态的海量用户、每日百万级的在岗骑手、全国近3000个县市区旗的地域覆盖，掘金广阔的Grocery零售市场，“让消费者购物更便捷，助零售商经营更高效”。</p>',
          linkUrl: '#',
          order: 3,
          isNotice: false,
        },
        {
          id: '76812117666',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/maiyao%402x.png',
          title: '美团买药',
          description:
            '<p>自2020年6月发布“美团买药”独立业务品牌以来，依托于美团覆盖全国的即时配送网络，美团买药为用户提供平均30分钟即时配送的购药服务，满足用户的急性用药及24小时夜间用药需求。</p>',
          linkUrl: '#',
          order: 4,
          isNotice: false,
        },
        {
          id: '461827030333',
          icon: '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E4%BA%A7%E5%93%81%E5%92%8C%E6%9C%8D%E5%8A%A1%2F36x36-1701344726972.png',
          title: '小象超市',
          description:
            '<p>小象超市为美团自营生鲜零售业务，定位为“30分钟快送超市”，采用“手机App+线下服务站”的模式，通过在社区设立的集存储、分拣、配送为一体的便民服务站，最快30分钟送达。</p>',
          linkUrl: '#',
          order: 5,
          isNotice: false,
        },
        {
          id: '575870611460',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/youxuan%402x.png',
          title: '美团优选',
          description:
            '<p>作为美团旗下的社区电商业务，美团优选于2020年7月上线，采取“今日下单+次日自提”的模式，为社区家庭用户精选高性价比的商品。</p>',
          linkUrl: '#',
          order: 6,
          isNotice: false,
        },
        {
          id: '112814165350',
          icon: '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E4%BA%A7%E5%93%81%E5%92%8C%E6%9C%8D%E5%8A%A1%2FKeeta-%E9%BB%84%E5%BA%95logo-1-1721824518186.png',
          title: 'Keeta',
          description:
            '<p>Keeta是美团旗下的独立品牌，专注于国际市场的餐饮与商品即时配送服务，致力推进全球市场的创新发展，实践“帮大家吃得更好，生活更好”的公司使命。2023年Keeta在香港启航，仅8个月便取得香港市场订单量第一。而在中东，Keeta已经覆盖沙特阿拉伯所有主要城市，正加速向更多市场扩张！</p>',
          linkUrl: '#',
          order: 7,
          isNotice: false,
        },
        {
          id: '511874345057',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/kuailv%402x.png',
          title: '快驴进货',
          description:
            '<p>快驴进货是美团深入餐饮产业链上游，推出的一站式餐饮供应链平台，为餐饮商户提供食材、餐厨用品、酒水饮料等在内的各种商品，协助餐饮商户以更低成本，更高效率的方式来获取安全可靠的食材供应。</p>',
          linkUrl: '#',
          order: 8,
          isNotice: false,
        },
        {
          id: '103806364151',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/meishi%402x.png',
          title: '美团美食',
          description:
            '<p>美团美食致力于为消费者提供优质的消费体验，帮商家创造更多生意、带来美好生活。美团美食面向消费者提供包括套餐、代金券、买单、预订等在内的产品和服务，并发布黑珍珠餐厅指南、大众点评必吃榜等榜单。</p>',
          linkUrl: '#',
          order: 9,
          isNotice: false,
        },
        {
          id: '765841045731',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/jiudian%402x.png',
          title: '美团酒店',
          description:
            '<p>美团酒店是美团旗下的综合住宿服务平台，秉承“帮大家住得更好”的使命。在用户侧，美团酒店专注于挖掘多样住宿场景，满足用户求新、求变的入住需求，为用户提供更多入住体验；在商家侧，美团酒店致力于科技创新，助力酒店商家综合收益提升，不断推进行业数字化发展。</p>',
          linkUrl: '#',
          order: 10,
          isNotice: false,
        },
        {
          id: '550854103273',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/menpiao%402x.png',
          title: '美团门票',
          description:
            '<p>美团门票是美团旗下的综合旅游度假服务平台。成立以来，形成了以景点门票为核心，涉及周边游、跟团游等多种业务的综合旅游度假服务在线平台，始终秉承“帮大家玩得更好”的使命，帮景区更好的服务游客。</p>',
          linkUrl: '#',
          order: 11,
          isNotice: false,
        },
        {
          id: '641832462754',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/xiuxianwanle%402x.png',
          title: '美团休闲娱乐',
          description:
            '<p>休闲娱乐业务涵盖足疗按摩、洗浴汗蒸、KTV、酒吧、运动健身、密室剧本杀轰趴、新奇体验、网吧电竞、采摘农家乐、茶馆、DIY手工坊、游乐游艺、宠物、爱车等数十个二级品类，联合商家打造出“欢洗节”、“酒吧指南”等IP活动，是消费者找“休闲玩乐”不可或缺的平台。</p>',
          linkUrl: '#',
          order: 12,
          isNotice: false,
        },
        {
          id: '571812653160',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/meituan%402x.png',
          title: '美团<i class="circle"></i>丽人',
          description:
            '<p>美团丽人业务深度融合线上线下，从“店”和“人”两个核心点切入，通过模式创新和科技创新助力商户数字化转型，与行业参与者共建新美业生态，为用户提供更好的变美服务。</p>',
          linkUrl: '#',
          order: 13,
          isNotice: false,
        },
        {
          id: '627866460671',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/danche%402x.png',
          title: '美团单车',
          description:
            '<p>美团单车业务作为城市中短距离出行工具，提供便捷、高效、绿色环保的共享出行服务，帮助消费者轻松串联起“吃喝玩乐”多场景美好生活。</p>',
          linkUrl: '#',
          order: 14,
          isNotice: false,
        },
        {
          id: '554824257606',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/distribution_m.png',
          title: '美团<i class="circle"></i>配送',
          description:
            '<p>美团配送是美团旗下的即时物流平台，拥有强大的实时配送网络，满足商户、消费者的多种需求。目前，美团配送单日完成订单量突破4000万，已经连接起630万商家、4.6亿消费者、近400万骑手和各类生态合作伙伴。</p>',
          linkUrl: '#',
          order: 15,
          isNotice: false,
        },
        {
          id: '636811613322',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/meituan%402x.png',
          title: '美团<i class="circle"></i>自动车配送',
          description:
            '<p>美团自动车以自研L4级自动驾驶软硬件技术为核心，与美团即时零售业务结合，形成满足公开道路、校园、社区、工业园区等室外全场景下的自动配送整体解决方案。截至2023年3月底，美团自动配送车已经累计给用户配送超299万单。</p>',
          linkUrl: '#',
          order: 16,
          isNotice: false,
        },
        {
          id: '626821460477',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/meituan%402x.png',
          title: '美团<i class="circle"></i>无人机',
          description:
            '<p>为了更好地提升城市即时配送的效率与体验，2017年，美团启动了无人机配送服务的探索，通过科技创新推动履约工具变革，加快建设空地协同的本地即时配送网络。</p><p>截至2024年6月底，美团无人机已在深圳、上海、广州等城市开通31条航线，并累计完成订单超30万单。</p>',
          linkUrl: '#',
          order: 17,
          isNotice: false,
        },
        {
          id: '252873203332',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/meituan%402x.png',
          title: '美团<i class="circle"></i>餐饮系统',
          description:
            '<p>美团餐饮系统为餐饮商户提供餐厅数字化解决方案，帮餐厅实现从前厅管理、后厨生产管理、会员管理、线上运营管理到供应链管理的数字化经营。</p>',
          linkUrl: '#',
          order: 18,
          isNotice: false,
        },
        {
          id: '243867561011',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/team/jinrongfuwu%403x.png',
          title: '美团支付',
          description:
            '<p>美团支付致力于为个人和企业用户提供安全、方便、快捷的综合支付解决方案，通过建立金融级大规模业务处理架构和资金安全方案体系，以流畅多样的支付方式、便捷快速的支付服务，保障每一笔支付安全，让客户在移动时代享受一站式的支付生活。</p>',
          linkUrl: '#',
          order: 19,
          isNotice: false,
        },
      ],
    },
    {
      id: '72',
      sectionName: '美团简介',
      sections: [
        {
          id: '45863326113',
          icon: 'NULL',
          title: '美团官网',
          linkUrl: 'https://about.meituan.com?source=zhaopin',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/meituan_introduce_3_mobile.png',
          order: 0,
          isNotice: false,
        },
        {
          id: '464864407310',
          icon: 'NULL',
          title: '我们的科技',
          linkUrl: 'https://about.meituan.com/technology?source=zhaopin',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E4%BA%A7%E5%93%81%E5%92%8C%E6%9C%8D%E5%8A%A1%2Fkeji-1745806849093.png',
          order: 1,
          isNotice: false,
        },
        {
          id: '547836723365',
          icon: 'NULL',
          title: '企业社会责任',
          linkUrl: 'https://about.meituan.com/csr?source=zhaopin',
          imgUrl:
            '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/meituan_introduce_responsibility_mobile.png',
          order: 2,
          isNotice: false,
        },
      ],
    },
    {
      id: '73',
      sectionName: '工作在美团',
      sections: [
        {
          id: '350846045666',
          icon: 'NULL',
          title: '人才成长',
          secondTitle: '一起成长，一起更好',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/grow.png',
          order: 0,
          isNotice: false,
          bid: 'b_ead_u7m2at46_mc',
          code: '001',
        },
        {
          id: '561803776316',
          icon: 'NULL',
          title: '人文关怀',
          secondTitle: '人文关怀，时刻关爱',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/care%403x.png',
          order: 1,
          isNotice: false,
          bid: 'b_ead_hzoadr3y_mc',
          code: '002',
        },
        {
          id: '167827223336',
          icon: 'NULL',
          title: '文化活动',
          secondTitle: '快乐节日，多彩生活',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/festival.png',
          order: 2,
          isNotice: false,
          bid: 'b_ead_yo70wiae_mc',
          code: '003',
        },
        {
          id: '27800601614',
          icon: 'NULL',
          title: '员工公益',
          secondTitle: '一边工作，一边公益',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/home/benefit.png',
          order: 3,
          isNotice: false,
          bid: 'b_ead_ud384uhd_mc',
          code: '004',
        },
      ],
    },
    {
      id: '74',
      sectionName: '关注我们',
      sections: [
        {
          id: '765841045732',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/qrcode/wx.png',
          title: '微信公众号',
          secondTitle: '关注美团招聘公众号',
          linkUrl: '/',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/qrcode/weixin.png',
          order: 0,
          isNotice: false,
          code: 'weixin',
        },
        {
          id: '765841045733',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/shipin/shipinhao3.png',
          title: '微信视频号',
          secondTitle: '关注美团招聘视频号',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/shipin/shipinhaocode.png',
          order: 1,
          isNotice: false,
          code: 'shipin',
        },
        {
          id: '765841045734',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/qrcode/b.png',
          title: 'B站',
          secondTitle: '关注美团招聘B站号',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/qrcode/bilibili.png',
          order: 2,
          isNotice: false,
          code: 'bilibili',
        },
        {
          id: '765841045735',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/qrcode/d.png',
          title: '抖音',
          secondTitle: '关注美团招聘抖音号',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/qrcode/douyin.png',
          order: 3,
          isNotice: false,
          code: 'douyin',
        },
        {
          id: '765841045736',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/qrcode/wb.png',
          title: '微博',
          secondTitle: '关注美团招聘微博号',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/qrcode/weibo.png',
          order: 4,
          isNotice: false,
          code: 'weibo',
        },
        {
          id: '765841045737',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/qrcode/zh.png',
          title: '知乎',
          secondTitle: '关注美团招聘知乎号',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/qrcode/zhihu.png',
          order: 5,
          isNotice: false,
          code: 'zhihu',
        },
        {
          id: '765841045738',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/qrcode/ly.png',
          title: '领英',
          secondTitle: '关注美团招聘领英号',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/qrcode/linying.png',
          order: 6,
          isNotice: false,
          code: 'linying',
        },
      ],
    },
    {
      id: '75',
      sectionName: '校园招聘-轮播',
      sections: [
        {
          id: '765841045739',
          icon: 'NULL',
          linkUrl: '/campus',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%A0%A1%E5%9B%AD%E6%8B%9B%E8%81%98%2Fzp_campus_mobile-1723086462289.png',
          order: 0,
          isNotice: false,
        },
        {
          id: '765841045742',
          icon: 'NULL',
          linkUrl: '/campus/schedule',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/banner/xingcheng.png',
          order: 1,
          isNotice: false,
        },
        {
          id: '765841045740',
          icon: 'NULL',
          linkUrl: '/beidou',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%A0%A1%E5%9B%AD%E6%8B%9B%E8%81%98%2F%E5%8C%97%E6%96%97%E8%AE%A1%E5%88%92banner1053_300-1689906309834.png',
          order: 2,
          isNotice: false,
        },
        {
          id: '765841045741',
          icon: 'NULL',
          linkUrl: '/qihang',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%A0%A1%E5%9B%AD%E6%8B%9B%E8%81%98%2Fm_qihang-1740981962281.jpg',
          order: 3,
          isNotice: false,
        },
        {
          id: '566846650335',
          linkUrl: '/campus?bg=BG021',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%A0%A1%E5%9B%AD%E6%8B%9B%E8%81%98%2Fchuhai_mobile-1745826377762.png',
          order: 4,
        },
        {
          id: '777823541755',
          linkUrl: '/position?hiringType=2_2',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%A0%A1%E5%9B%AD%E6%8B%9B%E8%81%98%2Fzhuanzheng-banner-mobile-1708482322312.png',
          order: 5,
        },
        {
          id: '777823541975',
          linkUrl: '/position/detail?jobUnionId=3524979618&highlightType=campus',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%A0%A1%E5%9B%AD%E6%8B%9B%E8%81%98%2FAI_PM_mobile-1752729326223.jpg',
          order: 6,
        },
      ],
    },
    {
      id: '79',
      sectionName: '事业部-美团优选',
      sections: [
        {
          id: '74860314671',
          icon: 'NULL',
          title: '美团电商',
          description:
            '<p>美团电商是美团旗下的B2C电商业务。秉承精选商家、严控品质的理念，旨在为消费者提供更省心的购物体验，服务人们对品质生活的追求。美团电商通过平台和自营等多种方式，甄选海量商品，精准满足用户的多样化消费需求，同时帮助平台商家有效触达目标受众，拓展线上经营阵地。</p><p>加入我们，你将会获得和专业电商团队共同成长的机会，与志同道合的人们相遇。创意的火花随时会被点燃，期待你的加入！</p>',
          order: 0,
          isNotice: false,
          code: '001',
        },
      ],
    },
    {
      id: '77',
      sectionName: '事业部-美团到家事业群',
      sections: [
        {
          id: '572860032205',
          icon: 'NULL',
          title: '美团外卖',
          description:
            '<p>美团外卖秉承“帮大家吃得更好，生活更好”的使命，始终聚焦于消费者用餐需求。我们通过科技连接消费者和商家，依托庞大的骑手团队，以“线上+线下”的业务模式，为消费者提供品质化、精细化、多样化的餐饮外卖服务。</p><p>外卖事业部是为用户与商家提供全链路交易服务的业务组织，围绕餐饮外卖搭建了包含外卖业务与创新孵化业务在内的多个部门。</p><p>我们的目标是帮助商家开源增收、提高经营效率，促进餐饮行业数字化，以及为更多用户提供更便捷更有品质的外卖服务。加入我们，一起为上亿用户提供更好的用餐体验，帮助大家吃得更好，生活更好！</p>',
          order: 0,
          isNotice: false,
          code: '001',
        },
        {
          id: '715852755441',
          icon: 'NULL',
          title: '美团配送',
          description:
            '<p>美团配送利用高效、稳定、广阔的配送网络和前沿科技能力为客户提供全方位同城物流综合解决方案，推动产业双向赋能，促进生态伙伴合作共赢，推进科技成果转化落地，助推经济社会繁荣发展。</p><p>当前，我们在loT智能设备、外卖柜、换电、无人配送体系等硬件设施与服务上不断推陈岀新，在持续优化骑手、消费者和商家体验的同时，持续建设全链路一体化的配送能力，通过科技赋能零售，组建打通上下游的一体化同城物流网络。</p><p>加入我们，一起把世界送到消费者手中！</p>',
          order: 1,
          isNotice: false,
          code: '002',
        },
        {
          id: '61803110347',
          icon: 'NULL',
          title: '美团闪购',
          description:
            '<p>美团闪购是美团旗下的LBS即时零售电商，2018年作为独立品牌发布。我们依托美团体系内的海量用户、每日百万级在岗骑手提供的小时达服务、覆盖全国超过2800个市区县的美团配送能力，在过去三年内已经为中国城镇居民提供了涵盖酒水零食、果蔬生鲜、鲜花绿植、宠物母婴、数码图书等诸多品类的即时零售服务。</p><p>这是一支斗志昂扬的团队，期待有想法、有事业心、渴望快速成长的你加入！让我们一同见证闪购发展，创造佳绩，逐梦前行！</p>',
          order: 2,
          isNotice: false,
          code: '003',
        },
        {
          id: '571860416764',
          icon: 'NULL',
          title: '美团买药',
          description:
            '<p>“美团买药”于2020年6月成为独立业务品牌，依托于美团覆盖全国的即时配送网络，为用户提供平均30分钟即时配送的购药服务，满足用户的急性用药及24小时夜间用药需求。同时，我们也在探索B2C零售业务和线上药师咨询服务，与全国超20家互联网医院合作开展线上复诊开方业务，为用户提供便利、专业的购药和用药服务。</p><p>在疫情的影响下，人们更倾向于选择在线医疗解决方案和药品配送服务。2021年6月，美团买药推出“小黄灯民生服务计划”，致力推动24小时药店的普及；2022年1月，美团买药推出“慢病关爱计划”，为疫情影响下不便购药的慢病患者提供切实帮助。美团买药希望成为“你的家庭药箱”，让健康相伴每个人。</p><p>这里有一群专业、专注、有耐心、有温度的小伙伴，在努力的把业务中的每一环做到极致，把最好的服务带给用户。希望同样对医药有热情的你加入我们，一起把健康带到每一个家庭。</p>',
          order: 3,
          isNotice: false,
          code: '004',
        },
        {
          id: '144857731112',
          icon: 'NULL',
          title: '美团无人机',
          description:
            '<p>为了更好地提升城市即时配送的效率与体验，美团于2017年启动了无人机配送服务的探索，通过科技创新推动履约工具变革，加快建设空地协同的本地即时配送网络，致力于为用户提供3公里、15分钟的标准配送服务。通过发展飞行器、导航控制、AI算法、航线管理、通讯系统五大自研技术能力，并适应社区、商场、写字楼等多种场景，让无人机与骑手形成人机协同的配送，真正实现“万物到家”。</p><p>截至2022年12月，美团无人机配送已在深圳5个商圈落地，航线覆盖18个社区和写字楼，完成面向真实用户的累计订单超12万单，并在北京、深圳等地测试机场完成了超过54万架次的飞行测试，配送飞行总时长2.8万小时以上。2023年1月，美团无人机通过中国民航局组织的专家审查，已取得超视距模式（BVLOS）特定类无人机试运行许可，未来会显著提升系统自动化程度和运行效率。</p><p>我们的使命是建设高效便捷的城市低空物流网络。加入我们，一同探索广阔蓝天，把路修到天上去，用科技帮大家吃得更好，生活更好。</p>',
          order: 4,
          isNotice: false,
          code: '005',
        },
      ],
    },
    {
      id: '78',
      sectionName: '事业部-美团到店事业群',
      sections: [
        {
          id: '340867211402',
          icon: 'NULL',
          title: '美团到店餐饮',
          description:
            '<p>美团到店餐饮拥有美团历史悠久的餐饮团购业务，聚焦美团“零售+科技”战略，为数以万计的餐饮商户提供一站式营销服务，为广大消费者提供优质的消费体验。我们帮助餐饮商户沉淀口碑、获取用户、增加复购等，持续提升商户数字化经营水平，同时秉承着“帮大家吃得更好，生活更好”的使命，面向消费者提供丰富的产品和服务，帮助消费者更好地作出消费决策。美团到店餐饮有高效成熟的管理体系，我们还将为你提供全面的人才培养机制和广阔的成长空间。让我们一起创造更大的价值，帮助消费者吃得更好，商户经营得更好！</p>',
          order: 0,
          isNotice: false,
          code: '004',
        },
        {
          id: '142832451534',
          icon: 'NULL',
          title: '美团酒店',
          description:
            '<p>美团酒店是美团旗下的综合住宿服务平台。成立以来，我们一直坚定践行“帮大家住得更好”的使命，不断提升用户的住宿体验；同时，我们也助力酒店商家提升综合收益，肩负社会责任、行业责任，共同推动建设更好的酒店市场。</p><p>我们是一支求真务实、团结一致、持续奋斗、拥抱变化的队伍，致力于成为尊重员工、让员工有成就感的团队。我们践行“以客户为中心”的理念，打造训练有素的战役文化；我们在长坡厚雪的业务赛道上，长期有耐心，不断精益每一步；我们坚持终身学习成长，使人才成为组织发展最宝贵的财富。未来如星辰，欢迎你的加入，携手建设我们共同的酒店事业！</p>',
          order: 1,
          isNotice: false,
          code: '005',
        },
        {
          id: '140850666600',
          icon: 'NULL',
          title: '美团门票度假和交通',
          description:
            '<p>门票度假和交通事业部是美团旗下综合旅游度假及出行服务平台，业务涵盖境内外景点门票预订、交通票务（机票、火车票、汽车票）预订、周边游及跟团游等。我们秉承“帮大家玩得更好”的使命，业务覆盖游玩及出行场景，为用户提供从资讯到交易的全程服务。</p><p>门票度假业务致力于提升用户在景区的消费便利度，帮助景区构建用户品牌认知，共建智慧景区。交通业务致力于为用户提供更便捷、优质的出行服务，运用数字化技术助力行业发展，协同产业链共建合作生态。同时，我们也努力肩负更多行业和社会责任，携手商家，共同推动建设更好的旅游度假和出行市场。</p><p>我们是一个简单、纯粹、可依赖的团队，加入我们，你将成为提升用户游玩及出行体验的重要成员！</p>',
          order: 2,
          isNotice: false,
          code: '006',
        },
        {
          id: '1845040232',
          icon: 'NULL',
          title: '美团民宿',
          description:
            '<p>美团民宿是美团旗下的民宿预订平台，精准满足年轻一代个性化、多样化住宿需求，专注为消费者提供“住得不一样”的旅居体验。从2017年4月上线至今，美团民宿已逐渐成长为拥有超过20万活跃房东和95万在线房源、业务遍及全国350多个城市的平台。</p><p>民宿平台不仅为助力房东们线上经营，让更多人可以发现、体验别样的民宿生活，还为房东们搭建起沟通的桥梁，让大家共同学习、交流和成长，分享知识和热爱，一同塑造更好的民宿行业。</p><p>我们是一支有活力、有朝气、有梦想的年轻队伍，汇聚了一群热爱民宿的运营达人、销售精英、技术大牛、产品大咖和设计大师。团队以追求成长、创造价值为导向，期待你的加入，共赴民宿美好的未来！</p>',
          order: 3,
          isNotice: false,
          code: '007',
        },
        {
          id: '312812771007',
          icon: 'NULL',
          title: '美团到店综合业务',
          description:
            '<p>到店综合业务涵盖洗浴、KTV、足疗按摩、剧本杀密室、丽人、医美医疗、教育培训、亲子、结婚、运动健身、家居、宠物、酒吧、家政维修等数十个重点生活服务细分行业。</p><p>我们为近200个本地生活服务行业提供营销、经营等数字化服务，链接本地消费需求和本地商家优质服务，搭建信息和交易平台，提供双边价值。我们作为美团到店业务重要板块之一，通过将信息及服务的线上化，为用户提供更多美好生活方式的选择，帮助商户在平台上更好地经营和发展，持续为公司贡献增长。</p><p>这里有着多元的业务布局，有着富有挑战和影响力的工作内容，为你提供丰富的视野、持续的成长和发展机会，引领你发现更多可能。期待优秀的你与我们携手同行！</p>',
          order: 4,
          isNotice: false,
          code: '003',
        },
        {
          id: '611805175412',
          icon: 'NULL',
          title: '美团餐饮系统',
          description:
            '<p>美团餐饮系统为餐饮企业提供一站式IT解决方案，帮助餐饮商户实现从供应链管理、生产管理、前厅管理到外卖的数字化经营。美团餐饮系统不仅打通了餐厅和平台，更帮助餐厅连接客人，让商户更了解顾客需求，在帮助商户做商业决策的同时给顾客带来更好的消费体验。</p><p>我们持续建设和提升产研、销售、服务的核心能力，通过全新升级的美团餐饮系统一体化软硬件产品，助力餐饮商户进行线上化经营，帮助商户在推广新店、提升效率、降低成本、会员营销、流量扶持、智慧选址、供应链管理等方面强化经营能力。团队汇集了餐饮和SaaS领域的优秀人才，秉持着“以客户为中心”的初心和“长期有耐心”的耕耘精神，求真、敬畏、敢于自我否定、善于快速学习。期待同样愿意长期致力于餐饮产业数字化、智能化的你加入我们的团队，共同进步共同成长！</p>',
          order: 5,
          isNotice: false,
          code: '001',
        },
        {
          id: '535847717322',
          icon: 'NULL',
          title: '美团充电宝',
          description:
            '<p>美团充电宝是服务零售中的共享租赁业务，承接美团使命，致力让大家充电更简单。</p><p>美团充电宝业务以应急充电功能为服务核心，覆盖吃喝玩乐生活全场景。目前，已在全国超过2000多个城市的餐饮、娱乐、机场、地铁、火车站、医院、学校、景区等公共区域及场所提供充电服务，铺设机柜超过百万，有KA、直营、渠道合作商多种业务模式，随时随地保障和满足消费者的充电需求。</p><p>我们的业务资产数量多、场景多元化，追求精益管理。我们的团队大咖云集，崇尚自主驱动，求真务实。我们正处在快速发展期，规模持续增长，目标是市场规模和利润水平双第一。我们的管理者关注团队每个成员的成长，为每个人提供适合自身发展的机会。</p><p>广阔天地、大有作为，美团充电宝期待你的加入！</p>',
          order: 6,
          isNotice: false,
          code: '002',
        },
      ],
    },
    {
      id: '80',
      sectionName: '了解美团-工作在美团',
      sections: [
        {
          id: '777823541647',
          icon: 'NULL',
          title: '一起成长，一起更好',
          secondTitle:
            '我们积累了完整的工作方法论，拥有多元的业务落地场景和顶尖的团队，帮助你在实践中学习，稳扎稳打地实现职业理想、成为更好的自己！',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/aboutImg/1.png',
          order: 0,
          isNotice: false,
          extra: ['81'],
          code: '001',
        },
        {
          id: '777823541648',
          icon: 'NULL',
          title: '人文关怀，时刻关爱',
          secondTitle: '时刻关心你的工作体验与生活状态，希望你的每一天都丰富而美好！',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/aboutImg/care%403x.png',
          order: 1,
          isNotice: false,
          extra: ['83'],
          code: '002',
        },
        {
          id: '777823541649',
          icon: 'NULL',
          title: '快乐节日，多彩生活',
          secondTitle: '与你一起走过每个重要节日，一起庆祝你的每个人生里程碑，一起让生活更美好！',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/aboutImg/2.png',
          order: 2,
          isNotice: false,
          extra: ['84'],
          code: '003',
        },
        {
          id: '777823541650',
          icon: 'NULL',
          title: '一边工作，一边公益',
          secondTitle: '美团人相信，每个人都可以做一点好事，在工作中也有机会做公益。',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/aboutImg/work_and_welfare_mobile.png',
          order: 3,
          isNotice: false,
          extra: ['82'],
          code: '004',
        },
      ],
    },
    {
      id: '81',
      sectionName: '工作在美团-一起成长',
      sections: [
        {
          id: '426832135740',
          icon: 'NULL',
          title: '完善的发展通道',
          secondTitle: '成熟的晋升体系、健全的领导梯队、开放的内部流动机制，为你的职业发展保驾护航。',
          order: 0,
          isNotice: false,
        },
        {
          id: '736820731312',
          icon: 'NULL',
          title: '丰富的学习资源',
          secondTitle:
            '55,000多门线上课程、定制化的培养项目、灵活多样的学习方式，帮助你全面提升职场通用技能、专业技能及管理能力。',
          order: 1,
          isNotice: false,
        },
        {
          id: '136864750703',
          icon: 'NULL',
          title: '新员工培养计划',
          secondTitle:
            '我们为加入美团的你提供完善的融入和成长计划，通过文化、制度、通用力、专业力的学习，帮助你熟悉业务，理解文化，成长为基本功扎实、业务能力强的骨干人才，和业务一起茁壮发展。',
          order: 2,
          isNotice: false,
        },
      ],
    },
    {
      id: '83',
      sectionName: '工作在美团-人文关怀',
      sections: [
        {
          id: '755845506375',
          icon: 'NULL',
          title: '呵护你的身心健康',
          secondTitle:
            '免费健身房、年度体检、健康驿站以及24小时心理咨询服务，倡导“每天运动30分钟”，结伴打卡锻炼身体，坚持运动，更加健康！',
          order: 0,
          isNotice: false,
        },
        {
          id: '216823144010',
          icon: 'NULL',
          title: '贴心的职场生活服务',
          secondTitle:
            '地铁摆渡车、长线巴士、食堂让你在工作之余更省心，员工服务中心、母婴室等服务和设施都是你的职场生活小帮手。',
          order: 1,
          isNotice: false,
        },
        {
          id: '37841426355',
          icon: 'NULL',
          title: '提供充足的假期',
          secondTitle:
            '年假、全薪及带薪病假、婚假、产假及陪产假、育儿假等多种类型的假期，让你可以更充分地休息娱乐，陪伴身边那些重要的人。',
          order: 2,
          isNotice: false,
        },
      ],
    },
    {
      id: '84',
      sectionName: '工作在美团-快乐节日',
      sections: [
        {
          id: '336833616351',
          icon: 'NULL',
          title: '欢度重要节日',
          secondTitle: '在3.8小美节、6.1家庭日、中秋节、春节等重要节日举办文化活动，为你和你的家人送上祝福。',
          order: 0,
          isNotice: false,
        },
        {
          id: '354815344605',
          icon: 'NULL',
          title: '纪念重要时刻',
          secondTitle:
            '你的入职三年、五年和十年纪念日，以及结婚、生子的重要时刻，都会收到定制手办和专属礼物，一起庆祝每个里程碑！',
          order: 1,
          isNotice: false,
        },
        {
          id: '457856132167',
          icon: 'NULL',
          title: '丰富的赛事活动',
          secondTitle:
            '我们有40多个文体俱乐部，分布在各个城市，一起踢足球、打游戏、来一场剧本杀，还有“萝卜坑”相亲、嗨歌、美食俱乐部，在美团找到志同道合的好朋友。',
          order: 2,
          isNotice: false,
        },
      ],
    },
    {
      id: '82',
      sectionName: '工作在美团-一边工作',
      sections: [
        {
          id: '241865045234',
          icon: 'NULL',
          title: '做个公益月捐人',
          secondTitle:
            '加入员工公益月捐，每天捐出1元钱给袋鼠宝贝公益计划，为全行业骑手子女提供大病救助金，点亮专属公益勋章。',
          order: 0,
          isNotice: false,
        },
        {
          id: '734847266203',
          icon: 'NULL',
          title: '让公益融入生活',
          secondTitle:
            '点外卖不要一次性餐具、低碳出行、旧衣捐赠、塑料瓶回收等力所能及的“日常小事”，都可以解锁你的公益成就。',
          order: 1,
          isNotice: false,
        },
        {
          id: '640843207763',
          icon: 'NULL',
          title: '带动业务伙伴做公益',
          secondTitle:
            '你可以带动自己服务的商家每笔订单捐一毛，也可以带动业务的用户为公益项目捐款，在工作中放大你的责任和善意。',
          order: 2,
          isNotice: false,
        },
      ],
    },
    {
      id: '85',
      sectionName: '社招问题',
      sections: [
        {
          id: '376816657526',
          icon: 'NULL',
          title: '全流程',
          order: 0,
          isNotice: false,
          extra: ['86'],
        },
        {
          id: '440860321063',
          icon: 'NULL',
          title: '查找岗位',
          order: 1,
          isNotice: false,
          extra: ['88'],
        },
        {
          id: '162841243644',
          icon: 'NULL',
          title: '投递简历',
          order: 2,
          isNotice: false,
          extra: ['87'],
        },
        {
          id: '652841122352',
          icon: 'NULL',
          title: '面试邀约与面试准备',
          order: 3,
          isNotice: false,
          extra: ['90'],
        },
        {
          id: '246805336332',
          icon: 'NULL',
          title: '面试进度与面试结果',
          order: 4,
          isNotice: false,
          extra: ['89'],
        },
      ],
    },
    {
      id: '88',
      sectionName: '社招问题-查找岗位',
      sections: [
        {
          id: '777823541652',
          icon: 'NULL',
          title: '官网上的岗位是目前真实招聘的岗位吗？',
          description: '<p>是的。官网上发布的岗位，均为当前在招聘的岗位。</p>',
          linkUrl: '/',
          order: 0,
          isNotice: false,
        },
        {
          id: '777823541653',
          icon: 'NULL',
          title: '如何快速查询到符合条件的目标岗位？',
          description:
            '<p>你可在<a target="_self" rel="noopener noreferrer nofollow" href="/m/social">https://zhaopin.meituan.com/m/social</a>界面通过关键词进行查询，支持筛选城市、岗位类别、工作经验进行更精确查询哦。</p>',
          linkUrl: '/',
          order: 1,
          isNotice: false,
        },
      ],
    },
    {
      id: '90',
      sectionName: '社招问题-面试邀约与面试准备',
      sections: [
        {
          id: '122804741733',
          icon: 'NULL',
          title: '收到面试邀约后发现简历需要更新，应该如何修改？',
          description: '<p>可以在美团招聘官网个人中心更新您的简历。面试官可以在看到您更新后的简历。</p>',
          linkUrl: '/',
          order: 0,
          isNotice: false,
        },
        {
          id: '204817411614',
          icon: 'NULL',
          title: '如何了解该岗位的更多信息？如岗位职责、面试轮次、面试官角色和每轮面试时长等。',
          description:
            '<p>在面试邀约前，可通过官网上对应职位的详细页面了解岗位职责。如需更多信息，可以在面试邀约时咨询与您联系的HR。</p>',
          linkUrl: '/',
          order: 1,
          isNotice: false,
        },
      ],
    },
    {
      id: '87',
      sectionName: '社招问题-投递简历',
      sections: [
        {
          id: '235846215557',
          icon: 'NULL',
          title: '一次可以投递几个职位？通过伯乐/猎头投递了岗位，还能在官网投递其他岗位吗？',
          description:
            '<p>投递数量不限。不过同一时间只能在一个岗位上面试哦，即一旦开始某岗位的面试流程，其他岗位的HR将无法操作您的简历，需等该岗位流程终止，才有可能继续其他岗位的流程。</p>',
          linkUrl: '/',
          order: 0,
          isNotice: false,
        },
        {
          id: '53843535265',
          icon: 'NULL',
          title: '填写简历时有哪些注意事项？',
          description:
            '<p>请确认您的简历信息内容是完善的、最新的，同时，请务必确认简历内容是真实的。正直诚信是美团的重要价值观，您提供的简历将应用于美团的各项招聘环节（包括但不限于面试、背调、入职等），一经发现信息不实，招聘/入职流程将立即终止。如已入职，美团有权按照试用期不符合录用条件或是严重违纪解除双方劳动合同。</p>',
          linkUrl: '/',
          order: 1,
          isNotice: true,
        },
        {
          id: '600876025323',
          icon: 'NULL',
          title: '投递简历后手机号/邮箱等信息发生变化，可以修改吗？在哪里修改？',
          description: '<p>可以，在美团招聘官网个人中心修改简历上对应的信息即可。</p>',
          linkUrl: '/',
          order: 2,
          isNotice: false,
        },
        {
          id: '153842631662',
          icon: 'NULL',
          title: '简历投递后大概多久会联系我？以什么形式？',
          description:
            '<p>如果简历通过筛选和评审，一般会在5个工作日内与您联系邀约面试，依据岗位性质不同，邀约面试可能会是电话、邮件、短信的方式。</p>',
          linkUrl: '/',
          order: 3,
          isNotice: false,
        },
      ],
    },
    {
      id: '89',
      sectionName: '社招问题-面试进度与面试结果',
      sections: [
        {
          id: '105877650516',
          icon: 'NULL',
          title: '如何了解我的面试进展？',
          description:
            '<p>一般来说，面试结束后5个工作日内，会通过电话/短信/邮件方式同步您面试结果。若超时未收到面试结果，可以发送邮件至<a target="_self" rel="noopener noreferrer nofollow" href="javascript: void(0)">zhaopin@meituan.com</a>，小助理会进行跟催哦。</p>',
          linkUrl: '/',
          order: 0,
          isNotice: false,
        },
        {
          id: '45823206110',
          icon: 'NULL',
          title: '面试未通过，可以投递其他岗位吗？',
          description: '<p>可以。在当前岗位流程终止后，可以投递其他岗位。</p>',
          linkUrl: '/',
          order: 1,
          isNotice: false,
        },
      ],
    },
    {
      id: '92',
      sectionName: '公告',
      sections: [
        {
          id: '777823541654',
          icon: 'NULL',
          title: '2025年春季校园招聘行程介绍',
          linkUrl: '/campus/schedule',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/gonggao/xingcheng.png',
          order: 0,
          isNotice: false,
          date: '2025/02/26',
        },
        {
          id: '777823541655',
          icon: 'NULL',
          title: '美团2025届北斗计划启动，让科技走向烟火人间',
          linkUrl: 'https://mp.weixin.qq.com/s/6oGd8yie7fR4bbPa4X0x3g',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/gonggao/beidou.png',
          order: 1,
          isNotice: false,
          date: '2024/06/11',
        },
        {
          id: '777823541656',
          icon: 'NULL',
          title: '来美团零售启航计划，极速开启面试，早拿offer早入职！欢迎零售类人才加入',
          linkUrl: 'https://mp.weixin.qq.com/s/arArIsVOX4mnI4a68cG5NQ',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/gonggao/qihang.png',
          order: 3,
          isNotice: false,
          date: '2025/03/12',
        },
      ],
    },
    {
      id: '93',
      sectionName: '校招TV-板块列表',
      sections: [
        {
          id: '246826476162',
          icon: 'NULL',
          title: '热门视频',
          order: 0,
          isNotice: false,
          extra: ['94'],
          code: '001',
        },
        {
          id: '637825334752',
          icon: 'NULL',
          title: '美团请回答',
          order: 1,
          isNotice: false,
          extra: ['97'],
          code: '002',
        },
        {
          id: '714830351377',
          icon: 'NULL',
          title: '求职干货',
          order: 2,
          isNotice: false,
          extra: ['95'],
          code: '003',
        },
        {
          id: '362874677035',
          icon: 'NULL',
          title: '直播回放',
          order: 3,
          isNotice: false,
          extra: ['96'],
          code: '004',
        },
      ],
    },
    {
      id: '94',
      sectionName: '校招TV-推荐观看',
      sections: [
        {
          id: '31835245311',
          icon: 'NULL',
          title: '美团校招宣传片——《我没想过成为这样的人》',
          secondTitle: '2:49',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV101.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/tv/5.png',
          order: 0,
          isNotice: false,
          date: '2021/09/14',
          code: 'TV101',
        },
        {
          id: '154814655545',
          icon: 'NULL',
          title: '【HR说】简历！面试官怎么看？',
          secondTitle: '5:18',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV102.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/tv/3.png',
          order: 1,
          isNotice: false,
          date: '2021/03/09',
          code: 'TV102',
        },
        {
          id: '577847317142',
          icon: 'NULL',
          title: '【纪录】美团“BetterU”校招生入职集训',
          secondTitle: '28:27',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV103.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/tv/2.png',
          order: 2,
          isNotice: false,
          date: '2021/12/29',
          code: 'TV103',
        },
        {
          id: '364873661314',
          icon: 'NULL',
          title: '欢迎来到北斗科技世界！',
          secondTitle: '1:22',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV104.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/tv/4.png',
          order: 3,
          isNotice: false,
          date: '2021/07/05',
          code: 'TV104',
        },
        {
          id: '130816016262',
          icon: 'NULL',
          title: '【不要慌挑战】——美团笔试攻略',
          secondTitle: '3:43',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV105.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/tv/1.png',
          order: 4,
          isNotice: false,
          date: '2021/08/20',
          code: 'TV105',
        },
      ],
    },
    {
      id: '97',
      sectionName: '校招TV-美团请回答',
      sections: [
        {
          id: '436830275417',
          icon: 'NULL',
          title: '美团“BetterU”校招生入职集训',
          secondTitle: '28:27',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV103.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/imgs/CampusTV/TV103.jpeg',
          order: 0,
          isNotice: false,
          date: '2021/12/29',
          code: 'TV201',
        },
        {
          id: '245860702227',
          icon: 'NULL',
          title: '零售人的茶话会',
          secondTitle: '1:07:46',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV202.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/imgs/CampusTV/TV202.png',
          order: 1,
          isNotice: false,
          date: "2021/09/17'",
          code: 'TV202',
        },
        {
          id: '717850570441',
          icon: 'NULL',
          title: '真假移动端',
          secondTitle: '1:26:47',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV203.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/imgs/CampusTV/TV203.jpeg',
          order: 2,
          isNotice: false,
          date: '2021/07/23',
          code: 'TV203',
        },
        {
          id: '421830716517',
          icon: 'NULL',
          title: '当科技走向人间烟火',
          secondTitle: '1:16:24',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV204.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/imgs/CampusTV/TV204.jpeg',
          order: 3,
          isNotice: false,
          date: '2021/07/17',
          code: 'TV204',
        },
        {
          id: '421826175471',
          icon: 'NULL',
          title: '值得收藏的校招最强攻略',
          secondTitle: '1:58:39',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV205.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/imgs/CampusTV/TV205.jpeg',
          order: 4,
          isNotice: false,
          date: '2021/08/24',
          code: 'TV205',
        },
      ],
    },
    {
      id: '95',
      sectionName: '校招TV-求职干货',
      sections: [
        {
          id: '615843120472',
          icon: 'NULL',
          title: '【干货】美团转正实习offer率85%？实习60天后我成功转正了！',
          secondTitle: '5:19',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV301.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/imgs/CampusTV/TV301.jpeg',
          order: 0,
          isNotice: false,
          date: '2022/03/31',
          code: 'TV301',
        },
        {
          id: '126855705417',
          icon: 'NULL',
          title: '00后不骗00后',
          secondTitle: '3:47',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV302.·mov',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/imgs/CampusTV/TV302.jpeg',
          order: 1,
          isNotice: false,
          date: '2021/12/14',
          code: 'TV302',
        },
        {
          id: '670857155577',
          icon: 'NULL',
          title: '导师=领路人？',
          secondTitle: '5:43',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV303.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/imgs/CampusTV/TV303.png',
          order: 2,
          isNotice: false,
          date: '2021/11/06',
          code: 'TV303',
        },
        {
          id: '764800540524',
          icon: 'NULL',
          title: '一名合格的美团实习生成长之路',
          secondTitle: '2:08',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV304.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/imgs/CampusTV/TV304.jpeg',
          order: 3,
          isNotice: false,
          date: '2021/07/30',
          code: 'TV304',
        },
        {
          id: '636835032460',
          icon: 'NULL',
          title: '【不要慌挑战】——美团笔试攻略',
          secondTitle: '3:43',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV105.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/imgs/CampusTV/TV105.png',
          order: 4,
          isNotice: false,
          date: '2021/08/20',
          code: 'TV305',
        },
      ],
    },
    {
      id: '96',
      sectionName: '校招TV-直播回放',
      sections: [
        {
          id: '437862063056',
          icon: 'NULL',
          title: '点评事业部、财务平台、战略与投资平台、人力资源平台',
          secondTitle: '1:51:04',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV401.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/imgs/CampusTV/TV401.jpeg',
          order: 0,
          isNotice: false,
          date: '2022/03/31',
          code: 'TV401',
        },
        {
          id: '521863621735',
          icon: 'NULL',
          title: '到店事业群、金融服务平台、公司事务平台',
          secondTitle: '1:29:39',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV402.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/imgs/CampusTV/TV402.jpeg',
          order: 1,
          isNotice: false,
          date: '2022/03/27',
          code: 'TV402',
        },
        {
          id: '353876570601',
          icon: 'NULL',
          title: '到家事业群、自动车配送部、网约车事业部、骑行事业',
          secondTitle: '1:50:26',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV403.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/imgs/CampusTV/TV403.png',
          order: 2,
          isNotice: false,
          date: '2022/03/24',
          code: 'TV403',
        },
        {
          id: '722814047510',
          icon: 'NULL',
          title: '美团平台、基础研发平台、客户服务与体验部在线答疑',
          secondTitle: '1:49:32',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV404.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/imgs/CampusTV/TV404.png',
          order: 3,
          isNotice: false,
          date: '2022/03/21',
          code: 'TV404',
        },
        {
          id: '610842453721',
          icon: 'NULL',
          title: '美团快驴、买菜、优选岗位的问题在这里都有答案',
          secondTitle: '1:30:22',
          linkUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/video/campusTV/TV405.mp4',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-prod/imgs/CampusTV/TV405.png',
          order: 4,
          isNotice: false,
          date: '2022/03/17',
          code: 'TV405',
        },
      ],
    },
    {
      id: '98',
      sectionName: '板块背景',
      sections: [
        {
          id: '777823541659',
          icon: 'NULL',
          title: '社会招聘',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/banner/shezhao.png',
          order: 0,
          isNotice: false,
          code: 'social',
        },
        {
          id: '777823541660',
          icon: 'NULL',
          title: '北斗计划',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/banner/beidou.png',
          order: 0,
          isNotice: false,
          code: 'beidou',
        },
        {
          id: '777823541661',
          icon: 'NULL',
          title: '启航计划',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%A0%A1%E5%9B%AD%E6%8B%9B%E8%81%98%2Fm_qihang-1740981962281.jpg',
          order: 0,
          isNotice: false,
          code: 'qihang',
        },
      ],
    },
    {
      id: '114',
      sectionName: '校招问题',
      sections: [
        {
          id: '777823541696',
          title: '简历投递相关',
          order: 0,
          extra: ['112'],
        },
        {
          id: '777823541697',
          title: '内推相关',
          order: 1,
          extra: ['110'],
        },
        {
          id: '777823541698',
          title: '笔试相关',
          order: 2,
          extra: ['111'],
        },
        {
          id: '777823541699',
          title: '面试/进展相关',
          order: 3,
          extra: ['113'],
        },
        {
          id: '777823541700',
          title: '其他信息',
          order: 4,
          extra: ['109'],
        },
      ],
    },
    {
      id: '109',
      sectionName: '校招问题-其他信息',
      sections: [
        {
          id: '777823541701',
          title: '从哪里可以了解美团相关校招信息？',
          description:
            '<p>① 登录美团校招官网</p><p>（<a target="_blank" rel="noopener noreferrer nofollow" href="https://zhaopin.meituan.com/m/campus">https://zhaopin.meituan.com/m/campus</a>）；</p><p>② 关注“美团招聘”官方微信公众号、官方小红书。</p>',
          linkUrl: '/',
          order: 0,
          isNotice: false,
        },
      ],
    },
    {
      id: '110',
      sectionName: '校招问题-内推相关',
      sections: [
        {
          id: '777823541702',
          title: '参与校招内推有哪些优势？',
          description:
            '<p>通过校招内推投递简历可以免简历筛选直通笔试；通过与学长学姐沟通，更深入地了解美团、了解具体岗位。</p>',
          linkUrl: '/',
          order: 0,
          isNotice: false,
        },
        {
          id: '777823541703',
          title: '怎样可以参与校招内推？',
          description:
            '<p>可以联系美团的在职员工、或者校园大使，获取内推二维码/字符码，扫码投递或网申时填写字符码，即可完成内推。</p>',
          linkUrl: '/',
          order: 1,
          isNotice: false,
        },
        {
          id: '777823541704',
          title: '我在投递的时候没有参加内推，之后还能参与校招内推吗？',
          description: '<p>投递职位后不能再参与内推，所以如想参与内推，记得提前找到内推二维码/字符码哦。</p>',
          linkUrl: '/',
          order: 2,
          isNotice: false,
        },
      ],
    },
    {
      id: '111',
      sectionName: '校招问题-笔试相关',
      sections: [
        {
          id: '777823541705',
          title: '我在笔试前没有收到笔试通知，怎么办？',
          description:
            '<p>笔试通知会在笔试前一天（周五）下午以短信和邮件的形式发放，若未收到，请按照以下顺序进行操作：</p><p>① 邮件/短信可能被拦截，及时查询邮件垃圾箱；</p><p>② 登录美团招聘官网</p><p>（<a target="_blank" rel="noopener noreferrer nofollow" href="https://zhaopin.meituan.com/m/campus">https://zhaopin.meituan.com/m/campus</a>），在右上方的个人主页中查询【投递记录】，点击【展开】可查询到笔试链接。同时检查并修改个人的网申电话和网申邮箱，以防错过重要信息；</p><p>③ 若以上方式仍未查询到，请尽快联系美团校招公邮<a target="_self" rel="noopener noreferrer nofollow" href="mailto:campus@meituan.com">campus@meituan.com</a>或者美团招聘公众号，我们将为你安排邮件和短信的补发。</p>',
          linkUrl: '/',
          order: 0,
          isNotice: false,
        },
        {
          id: '777823541706',
          title: '我没有时间参加本场笔试或者错过了笔试，怎么办？',
          description:
            '<p>如因特殊情况不能参加本场笔试，请根据笔试邮件中的提示【点击确认是否参加考试】，选择【放弃】，且不要在考试时间点进考试链接，考试将自动顺延至下一场。建议大家合理安排笔试时间，早参加笔试，早安排面试，才有机会早拿offer。</p>',
          linkUrl: '/',
          order: 1,
          isNotice: false,
        },
        {
          id: '777823541707',
          title: '我自己感觉本场笔试发挥不佳，还有重考的机会吗？',
          description:
            '<p>3月31日24:00前投递<span style=\'text-decoration: underline\'>2026届转正实习岗位</span>的同学，在进入面试前，拥有最多2次完成笔试的机会，笔试成绩取高值。第2次笔试报名方式在首次笔试结束界面，也可以联系<a target="_self" rel="noopener noreferrer nofollow" href="mailto:campus@meituan.com">campus@meituan.com</a>咨询。</p><br><p><em style=\'font-style: italic; font-size: 0.28rem\'>* 注：零售类、销售、客服、支持类部分岗位采取随到随测，不设2次笔试机会，请仔细阅读邮件信息。</em></p>',
          linkUrl: '/',
          order: 2,
          isNotice: false,
        },
        {
          id: '777823541708',
          title: '笔试成绩什么时候公布？',
          description: '<p>笔试成绩不会对外公布，仅供面试官参考。大家要认真对待笔试，好好发挥哦。</p>',
          linkUrl: '/',
          order: 3,
          isNotice: false,
        },
        {
          id: '777823541709',
          title: '我是通过内推码投递的简历，也需要参加笔试吗？',
          description:
            '<p>是的，内推免简历筛选环节，可直通笔试，并有机会优先面试。但是，同学必须有笔试成绩，才可以进入后续环节，请一定要重视笔试。</p>',
          linkUrl: '/',
          order: 4,
          isNotice: false,
        },
        {
          id: '777823541710',
          title: '如果重新选择参加笔试，招聘状态会变回【笔试待安排】流程吗？',
          description: '<p>不会，重考不耽误其他流程。</p>',
          linkUrl: '/',
          order: 5,
          isNotice: false,
        },
        {
          id: '777823541711',
          title: '已经收到面试邀约，还可以重考笔试吗？',
          description:
            '<p>不可以。已经收到面试邀约，或者完成面试的同学，不需要再重考笔试了。多次笔试就是为了帮助同学获得更高的进面概率，建议同学抓住机会，早面试早拿offer。</p>',
          linkUrl: '/',
          order: 6,
          isNotice: false,
        },
        {
          id: '777823541712',
          title: '报名参加重考后，如果又不想重考怎么办？',
          description:
            '<p>点击笔试通知邮件中的提示【点击确认是否参加考试】，选择【放弃】，不会再收到笔试通知，也不会影响已有的笔试成绩。</p>',
          linkUrl: '/',
          order: 7,
          isNotice: false,
        },
      ],
    },
    {
      id: '112',
      sectionName: '校招问题-简历投递相关',
      sections: [
        {
          id: '777823541713',
          title: '本次校招面向哪些同学开放？',
          description:
            '<p>本次常规校招分为转正实习生招聘和应届生招聘，转正实习生招聘面向毕业时间为2025年11月~2026年10月的境内外院校同学；应届生招聘面向毕业时间为2024年11月~2025年10月的境内外院校同学；北斗计划项目面向毕业时间为2024年1月~2025年12月的境内外院校同学。</p>',
          linkUrl: '/',
          order: 0,
          isNotice: true,
        },
        {
          id: '777823541714',
          title: '招聘职位的工作地点在哪儿？',
          description: '<p>每个招聘职位里都有工作地点的相关说明，同学可以仔细阅读职位描述。</p>',
          linkUrl: '/',
          order: 1,
          isNotice: true,
        },
        {
          id: '777823541715',
          title: '职位投递时选择“意向部门”有什么作用？',
          description:
            '<p>若无偏好，强烈建议选择“都喜欢”，所有在招该职位的部门都将看到你的简历；选择指定的“意向部门”，简历将优先分配给该部门，如果你的简历没有通过该部门的筛选，将被释放并有机会被其他部门筛选推进校招流程。</p>',
          linkUrl: '/',
          order: 2,
          isNotice: false,
        },
        {
          id: '777823541716',
          title: '职位投递成功后，还可以修改简历内容吗？',
          description:
            '<p>可以修改手机号、个人邮箱、简历附件等。请注意职位投递成功后，默认将按照投递志愿顺序流转，且不可进行修改（志愿职位、意向部门、意向城市均不可修改），请务必谨慎选择哦。</p>',
          linkUrl: '/',
          order: 3,
          isNotice: false,
        },
        {
          id: '777823541717',
          title: '填写简历时有哪些注意事项？',
          description:
            '<p>请确保手机号、个人邮箱及证件信息填写正确，方便我们与你取得联系（部分校园邮箱存在收不到通知的情况，推荐使用QQ邮箱、网易邮箱等）。此外，建议同学完整填写简历信息（教育经历、实习经历、项目经历、校园经历等），完整的简历便于面试官全面了解你。</p>',
          linkUrl: '/',
          order: 4,
          isNotice: false,
        },
        {
          id: '777823541718',
          title: '网申后手机号发生变化，应该如何变更？',
          description:
            '<p>请使用原手机号绑定的微信，扫码登录美团招聘官网（<a target="_blank" rel="noopener noreferrer nofollow" href="https://zhaopin.meituan.com/m/campus">https://zhaopin.meituan.com/m/campus</a>），点击右上角账号设置，更换手机号，然后按操作步骤绑定新手机号。更换完毕后，可使用新绑定的手机号短信登录招聘官网。</p>',
          linkUrl: '/',
          order: 5,
          isNotice: false,
        },
        {
          id: '777823541719',
          title: '在过往校招中投递过简历，没有面试/面试失败了，本次校招还可以投递吗？',
          description: '<p>欢迎再次投递，过往校招结果不会影响本次校招进程。</p>',
          linkUrl: '/',
          order: 6,
          isNotice: false,
        },
        {
          id: '777823541720',
          title: '志愿有先后顺序吗？必须填写3个志愿吗？可以后续再加志愿吗？可以修改志愿吗？',
          description:
            '<p>志愿有先后顺序，第1志愿结束后才会开启第2志愿。投递简历时志愿1是必填的，志愿2和志愿3选填，未填写的志愿可以后续补充，每人最多填写3个志愿。提交后志愿职位、意向部门、意向城市和志愿顺序均不可修改，请谨慎选择。</p>',
          linkUrl: '/',
          order: 7,
          isNotice: false,
        },
        {
          id: '777823541721',
          title: '为什么可以投递三个志愿？填写三个志愿有什么用？',
          description:
            '<p>为了给同学们提供更多加入美团的机会。当第1志愿面试失败或长时间未被发起面试，则依次启动第2、第3志愿。填写志愿前可提前了解职位要求、部门介绍等信息，可以帮同学们更好地选择、填写志愿。</p>',
          linkUrl: '/',
          order: 8,
          isNotice: false,
        },
      ],
    },
    {
      id: '113',
      sectionName: '校招问题-面试/进展相关',
      sections: [
        {
          id: '777823541722',
          title: '如何了解我的招聘进展呢？',
          description:
            '<p>笔、面试安排会通过短信及邮件通知。此外，同学可以登录美团校招官网，进入“投递记录”查看招聘进展，也可以通过“美团招聘”公众号，点击下方的“校招主页”按钮，侧边栏点击“个人中心”，查看招聘进展。如还有其他疑问，你可以发送【姓名+电话+邮箱+问题】至<a target="_self" rel="noopener noreferrer nofollow" href="mailto:campus@meituan.com">campus@meituan.com</a>进行咨询，或在“美团招聘”公众号留言，我们将倾情为你解答。</p>',
          linkUrl: '/',
          order: 0,
          isNotice: false,
        },
        {
          id: '777823541723',
          title: '完成笔试后多久才可以收到面试通知呢？',
          description:
            '<p>我们会根据内部招聘进度尽快安排面试，请耐心等待，如有面试安排，会通过邮件、短信及“美团招聘”公众号进行通知。</p>',
          linkUrl: '/',
          order: 1,
          isNotice: false,
        },
        {
          id: '777823541724',
          title: '为什么通知面试的职位与投递的职位不一样呢？',
          description:
            '<p>完成笔试后，所有职位的面试官都有机会看到你的简历，面试官会根据你的简历与岗位的匹配度决定是否发起面试，请相信面试官的判断，如果你不想参与其他职位的面试，可以在约面时直接拒绝，不会影响校招的流程。</p>',
          linkUrl: '/',
          order: 2,
          isNotice: false,
        },
        {
          id: '777823541725',
          title: '收到面试通知后，不想参加本次面试，应该怎么处理？',
          description:
            '<p>收到面试邀约后，如因时间冲突等原因无法参加面试，可直接联系面试通知中的联系人进行沟通；你也可以发送【姓名+电话+邮箱+问题】至<a target="_self" rel="noopener noreferrer nofollow" href="mailto:campus@meituan.com">campus@meituan.com</a>进行咨询。</p>',
          linkUrl: '/',
          order: 3,
          isNotice: false,
        },
      ],
    },
    {
      id: '120',
      sectionName: '校招行程-笔试时间表',
      sections: [
        {
          id: '777823541734',
          title: '2025年3月',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%A0%A1%E6%8B%9B%E8%A1%8C%E7%A8%8B%2Fimage_1740449106119-1740449160468.png',
          order: 0,
        },
        {
          id: '777823541735',
          title: '2025年4月',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%A0%A1%E6%8B%9B%E8%A1%8C%E7%A8%8B%2Fimage_1740449110404-1740449157846.png',
          order: 1,
        },
        {
          id: '777823541736',
          title: '2025年5月',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%A0%A1%E6%8B%9B%E8%A1%8C%E7%A8%8B%2Fimage_1740449113196-1740449157876.png',
          order: 2,
        },
      ],
    },
    {
      id: '122',
      sectionName: '校园招聘-分类',
      sections: [
        {
          id: '777823541744',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/campusType/yingjiezhaopin%403x.png',
          title: '应届校招',
          linkUrl: '/position?hiringType=1_1,1_3,1_4',
          order: 0,
          bid: 'b_ead_ccner64u_mc',
        },
        {
          id: '777823541745',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/campusType/beidoujihua%403x.png',
          title: '北斗计划',
          linkUrl: '/beidou',
          order: 1,
          bid: 'b_ead_ejug1ixw_mc',
        },
        {
          id: '777823541746',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/campusType/qihangjihua%403x.png',
          title: '零售启航计划',
          linkUrl: '/qihang',
          order: 2,
          bid: 'b_ead_qpg1ysjr_mc',
        },
        {
          id: '777823541747',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/campusType/zhuanzhengshixi%403x.png',
          title: '转正实习',
          linkUrl: '/position?hiringType=2_2',
          order: 3,
          bid: 'b_ead_o7vm9zpg_mc',
        },
        {
          id: '777823541748',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/campusType/richangshixi%403x.png',
          title: '日常实习',
          linkUrl: '/position?hiringType=2_6',
          order: 4,
          bid: 'b_ead_jwrp0s4y_mc',
        },
      ],
    },
    {
      id: '123',
      sectionName: '校园招聘-导航',
      sections: [
        {
          id: '777823541749',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/quickEntry/xiaozhaoxingcheng%402x.png',
          title: '校招行程',
          linkUrl: '/campus/schedule',
          order: 0,
          bid: 'b_ead_bb5kvhj6_mc',
        },
        {
          id: '777823541751',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/quickEntry/changjianwenti%402x.png',
          title: '常见问题',
          linkUrl: '/question/campus',
          order: 2,
          bid: 'b_ead_v7cydic4_mc',
        },
        {
          id: '777823541752',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/quickEntry/liaojiemeituan%402x.png',
          title: '了解美团',
          linkUrl: '/about/ourTeam',
          order: 3,
          bid: 'b_ead_c5uk5buq_mc',
        },
      ],
    },
    {
      id: '76',
      sectionName: '事业部',
      sections: [
        {
          id: '111867064313',
          icon: '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E4%BA%8B%E4%B8%9A%E9%83%A8%2Ficon-1721979836052.png',
          title: '核心本地商业',
          secondTitle: '',
          description:
            '<p>核心本地商业（Core Local Commerce）是美团“零售+科技”战略的重要载体，涵盖了到店餐饮、服务零售、酒店旅行、外卖、履约配送、闪购、医药健康等多个业务，覆盖了超过200个消费场景，致力于通过“随时随地”的商品和服务，满足消费者的多样性需求，帮大家吃得更好，生活更好。<br>核心本地商业扎根本地消费，围绕消费者的“吃、住、行、游、购、娱”进行深度创新，引领发展了即时零售、团购等多种消费业态，并在全国范围内广泛投资发展本地供给、履约平台等设施，助力创造产业、带动就业。<br>基于多年的持续投入，核心本地商业打造了连接全国超过一千万中小微企业的服务体系，以及全球最大的即时配送网络。由核心本地商业所推行的30分钟“万物到家”体系，已覆盖全国2800多个城镇，为数亿用户提供优质的商品与服务。<br>发展过程中，核心本地商业有效助力商超、连锁、本地小店等各类实体经济主体扩大交易规模、降低交易成本。截至目前，核心本地商业日均创造订单量数千万笔，助力千万商户实现了高质量发展。<br>未来，核心本地商业将继续践行美团“零售+科技”战略，通过更大的投资，更多的技术创新，支持、培育消费新业态，为促进消费、服务民生、带动就业作出力所能及的贡献。<br>欢迎优秀的你加入核心本地商业，我们携手助力市场繁荣，为用户创造更好的消费体验。</p>',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E4%BA%8B%E4%B8%9A%E9%83%A8%2F999-300-1721979821975.png',
          order: 0,
          extra: [],
          code: 'BGCLC',
        },
        {
          id: '107832254244',
          icon: '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E4%BA%8B%E4%B8%9A%E9%83%A8%2F%E9%A3%9F%E6%9D%82%E9%9B%B6%E5%94%AE-1727354064504.png',
          title: '食杂零售',
          secondTitle: '',
          description: '',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E4%BA%8B%E4%B8%9A%E9%83%A8%2F%E9%A3%9F%E6%9D%82%E9%9B%B6%E5%94%AE999x300-1727354166378.png',
          order: 1,
          isNotice: false,
          extra: ['158'],
          code: 'BG022',
        },
        {
          id: '524822063611',
          icon: '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E4%BA%8B%E4%B8%9A%E9%83%A8%2F%E8%BD%AF%E7%A1%AC%E4%BB%B6%E6%9C%8D%E5%8A%A1-1727354061904.png',
          title: '软硬件服务',
          secondTitle: '',
          description: '',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E4%BA%8B%E4%B8%9A%E9%83%A8%2F%E8%BD%AF%E7%A1%AC%E4%BB%B6%E6%9C%8D%E5%8A%A1999x300-1727354166354.png',
          order: 2,
          isNotice: false,
          extra: ['159'],
          code: 'BG024',
        },
        {
          id: '555833601330',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/team/zidongche%403x.png',
          title: '美团自动车配送',
          secondTitle: '用自动车让服务触达世界每个角落',
          description:
            '<p>美团自动车配送部成立于2016年，以自研L4级自动驾驶软硬件技术为核心，构建了涵盖软件、控制、硬件、整车测试等全栈技术体系，逐步成长为国内领先的自动配送企业。<br>在技术研发方面，我们采用基于BEV的融合感知、端到端行为预测、机器学习决策规划等先进技术，并通过多冗余硬件配置确保车辆在复杂路况下的安全行驶，自动驾驶算法团队博士占比高达30%。<br>在运营安全方面，美团建立了“人-车-云”主被动安全保障系统，制定了完备的分级响应制度，全方位保障自动驾驶行驶周期的安全。<br>美团自动配送车以自研L4级自动驾驶系统为核心，与美团外卖、小象超市、美团买药等即时零售业务结合，推出城市公开道路场景的末端即时自动配送整体解决方案。<br>截至2024年底，美团自动配送车完成室外全场景配送近500万单，自动驾驶总里程达到1300万公里，自动驾驶里程占比99%，测试和运营路线达到340条，服务覆盖数百个社区，通过与骑手协同的方式，为北京顺义、深圳坪山、深圳龙华等多个区域的居民提供生鲜食杂的即时配送服务。<br>欢迎加入美团自动车配送团队，与我们一起用科技推动即时零售再升级！</p>',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/bglogo/zidongche%403x.png',
          order: 4,
          isNotice: false,
          extra: [],
          code: 'BG009',
        },
        {
          id: '777823541952',
          icon: '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E4%BA%A7%E5%93%81%E5%92%8C%E6%9C%8D%E5%8A%A1%2Fwrj-1722940020622.png',
          title: '美团无人机',
          secondTitle: '',
          description:
            '<p>为了更好地提升城市即时配送的效率与体验，2017年，美团启动了无人机配送服务的探索，通过科技创新推动履约工具变革，加快建设空地协同的本地即时配送网络。目前，美团已初步完成了自主飞行无人机、智能化调度系统及高效率运营体系的研发建设工作，由此打造了一个服务于多场景、多天候的城市低空物流解决方案。</p><p>2021年初，美团无人机在深圳完成了首个面向真实用户的订单配送任务。截至2024年12月，美团无人机已在深圳、北京、上海、广州、南京等城市开通53条航线，并累计完成订单超45万。即时零售配送服务覆盖了办公、社区、景区、市政公园、校园、医疗、图书馆等多种场景，并为用户提供超9万种商品选择。在医疗场景中，美团无人机可围绕医疗血液、检验样本、院前急救物资、特殊药品等医疗物资配送需求建设端到端的全天时急送网络。</p>',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E4%BA%8B%E4%B8%9A%E9%83%A8%2Fwrj_banner_mobile-1722940462425.png',
          order: 5,
          extra: [],
          code: 'BG020',
        },
        {
          id: '514853757645',
          icon: '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E4%BA%8B%E4%B8%9A%E9%83%A8%2Fkeeta-20240926-1727354064519.png',
          title: 'Keeta',
          secondTitle: '',
          description:
            '<p>Keeta是「美团」的独立品牌，专注于国际市场的餐饮/商品即时配送业务，践行“帮大家吃得更好，生活更好”的使命。</p><p>自2010年3月成立以来，美团持续推动服务零售和商品零售在需求侧和供给侧的数字化升级，不断加大在新技术上的研发投入。</p><p>Keeta和美团始终以客户为中心，和广大合作伙伴一起努力为消费者提供品质服务。</p><p>欢迎具有全球化视野的你加入我们，一起探索新世界！</p>',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E4%BA%8B%E4%B8%9A%E9%83%A8%2FKeeta999x300-1727354168881.png',
          order: 6,
          isNotice: false,
          extra: [],
          code: 'BG021',
        },
        {
          id: '545841765200',
          icon: '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E4%BA%8B%E4%B8%9A%E9%83%A8%2FGN06-1727354061902.png',
          title: 'GN06',
          secondTitle: '',
          description:
            '<p>GN06负责美团创新探索性的AI应用，希望在AI时代，能在更多领域，帮助世界变得更好。<br>加入我们，一起摸索AI新世界！</p>',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E4%BA%8B%E4%B8%9A%E9%83%A8%2FGN06-999x300-1727354168878.jpg',
          order: 7,
          isNotice: false,
          extra: [],
          code: 'BG045',
        },
        {
          id: '622807751213',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/team/jinrongfuwu%403x.png',
          title: '美团金服',
          secondTitle: '科技连接金融，为美好生活创造小惊喜',
          description:
            '<p>美团金融服务平台成立于2016年，以“场景+金融”模式，携手合作伙伴构建开放生态，为美团平台用户和商户提供底层账户、支付通道、信贷、保险和理财等金融解决方案。我们致力于以科技为核心，助力金融机构打通金融普惠“最后一公里”。我们期待与大家共同完成每一件平凡而卓越的事情，一起为用户提供优质的产品体验，守护用户的资金安全，让生活变得更美好。</p>',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/bglogo/jinrongfuwu%403x.png',
          order: 8,
          isNotice: false,
          extra: [],
          code: 'BG003',
        },
        {
          id: '174871333012',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/team/zhanlvetouzi%403x.png',
          title: '战略与投资平台',
          secondTitle: '为公司发现机遇，帮业务赢得胜利',
          description:
            '<p>战略与投资平台负责美团公司层面的战略方向与行业研究、业务机会的判断、投资并购、业务经营管理、资本市场运作等多个方向。自2014年成立以来，战投不断推动新的战略机会的探索，与各业务紧密协作，推动公司进行战略与讨论决策。我们投资的领域包括前沿科技、消费零售等，近几年来在前沿科技领域加大了投资布局。</p><p>战略与投资平台的使命是帮助公司抓住战略性机会，为公司建设持续发现机会、实现长期价值的能力。</p><p>我们欢迎优秀的你和我们一起创造未来，改变世界。</p>',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/bglogo/zhanlvetouzi%403x.png',
          order: 9,
          isNotice: false,
          extra: [],
          code: 'BG016',
        },
        {
          id: '61867400500',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/team/new/caiwupingtai_mobile.png',
          title: '财务平台',
          secondTitle: '建设业界一流的财务管理和经营支持体系，助力公司业务的持续发展和价值创造',
          description:
            '<p>财务平台负责公司整体和各业务层面的财务管理工作，通过建设专业、全面、复合的财务管理能力和与业务经营的紧密结合来支持公司健康发展。目前财务平台拥有财务会计、财务报告、资金管理、税务管理、财务共享、财务系统、规划分析、财务BP和内控内审等主要工作方向。我们的目标是建设业界一流的财务管理能力和经营支持体系，为公司战略的正确落地、投入效率的持续提升、业务价值的不断增长保驾护航。</p><p>欢迎加入财务平台，携手一起向未来！</p>',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/bglogo/caiwu%403x.png',
          order: 10,
          isNotice: false,
          extra: [],
          code: 'BG015',
        },
        {
          id: '435845650467',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/team/new/gongsishiwu_mobile.png',
          title: '公司事务平台',
          secondTitle: '助力业务可持续发展，助力公司创造更多社会价值',
          description:
            '<p>公司事务平台负责构建公司的公共战略体系，助力业务可持续发展及公司对外影响力的提升。通过内外部风险管理，确保公司合规发展；通过深耕公共战略，推动内外良好沟通，连接公司发展与社会期待，助力业务高质量发展；通过管理社会责任议题、公益投入等，助力公司创造更多社会价值；同时为公司提供行政、采购等基础服务。我们坚持“懂业务、拿结果，勇担当、善协同，不唯上、只唯真”的工作理念，期待具有公共战略素养、了解公司治理逻辑的你加入！</p>',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/bglogo/gongsishiwu%403x.png',
          order: 11,
          isNotice: false,
          extra: [],
          code: 'BG010',
        },
        {
          id: '756817361444',
          icon: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/team/new/renliziyuan_mobile.png',
          title: '人力资源平台',
          secondTitle: '建设有生命力的组织，为客户和社会创造价值',
          description:
            '<p>美团HR的使命是“建设有生命力的组织，为客户和社会创造价值”。 我们认为HR的工作不是以自身“专业”为中心，而是要建设有助于员工发挥创造力的环境，支持他们更好地为外部客户和社会创造价值，也实现组织自身的进化和传承。</p><p>在这个过程中，我们的每位HR同学都是“业务的战略合作伙伴、组织能力的建设者、美团精神的布道者、员工的成长伙伴”。我们要设计面向长期支撑组织有效运转的机制，我们要求真务实地帮业务解决发展中的问题和阵痛，我们要支持每一位员工历经磨炼收获成长。我们要影响世界，驱动更美好的变化发生。</p><p>如果这也是你追求的，欢迎加入美团HR，与我们一路同行！</p>',
          imgUrl: '//s3plus.meituan.net/zhaopin-official-website-mobile-prod/bglogo/hr%403x.png',
          order: 12,
          isNotice: false,
          extra: [],
          code: 'BG011',
        },
      ],
    },
    {
      id: '140',
      sectionName: '新北斗计划-时间轴',
      sections: [
        {
          id: '777823541811',
          title: '2016',
          description: '<p>启动自动配送车研发，已累计配送真实订单近400万单。</p>',
          order: 0,
        },
        {
          id: '777823541812',
          title: '2017',
          description:
            '<p>启动无人机研发，已累计配送真实订单超30万单。</p><p>启动北斗计划的招聘，共引入百余位顶尖科技人才。</p>',
          order: 1,
        },
        {
          id: '777823541813',
          title: '2023',
          description: '<p>完成自研大模型备案，目前已应用于多个业务场景。</p>',
          order: 2,
        },
        {
          id: '777823541814',
          title: '今天',
          description: '<p>我们年研发投入212亿。</p>',
          order: 3,
        },
      ],
    },
    {
      id: '141',
      sectionName: '新北斗计划-模块列表',
      sections: [
        {
          id: '777823541815',
          title: '我们能给你什么？',
          secondTitle: '无',
          linkUrl: '无',
          order: 0,
          extra: ['142'],
        },
        {
          id: '777823541816',
          title: '我们期待怎样的你？',
          secondTitle: '非常、非常、非常想用科技让这个世界更美好！',
          linkUrl: '毕业时间：2025年1月-2026年12月（不限学历）',
          order: 1,
          extra: ['143'],
        },
        {
          id: '777823541817',
          title: '我们提供哪些职位？',
          secondTitle: '热招职位包括但不限于上述方向，欢迎点击链接了解详情',
          linkUrl: '无',
          order: 2,
          extra: ['144'],
        },
        {
          id: '777823541818',
          title: '北斗人物',
          secondTitle: '无',
          linkUrl: '无',
          order: 3,
          extra: ['150'],
        },
      ],
    },
    {
      id: '142',
      sectionName: '新北斗计划-我们能给你什么',
      sections: [
        {
          id: '777823541819',
          title: '丰富的场景、海量的数据',
          secondTitle:
            '美团既有大模型、自动配送车、无人机、搜广推等精尖技术的应用场景，也有客服、销售等业务流程的改善空间。 近7亿用户，亿级的日订单量，为技术提升提供充足的数据资源。',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%96%B0%E5%8C%97%E6%96%97%E8%AE%A1%E5%88%92%2Fbeidou_section_bg1-1721616990273.png',
          order: 0,
        },
        {
          id: '777823541820',
          title: 'AI领域领先的算力、人均算力资源',
          secondTitle: '数万卡的资源，足以面对近期挑战；不赛马，人均算力资源行业领先。',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%96%B0%E5%8C%97%E6%96%97%E8%AE%A1%E5%88%92%2Fbeidou_section_bg2-1721617767877.png',
          order: 1,
        },
        {
          id: '777823541821',
          title: '行业领先的技术团队',
          secondTitle: '行业大咖、顶会作者，坚持招了7年的百余名北斗。',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%96%B0%E5%8C%97%E6%96%97%E8%AE%A1%E5%88%92%2Fbeidou_section_bg1-1721617936417.png',
          order: 2,
        },
        {
          id: '777823541822',
          title: '极具竞争力的薪酬',
          secondTitle: '别家给得起的，我们都给得起！',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%96%B0%E5%8C%97%E6%96%97%E8%AE%A1%E5%88%92%2Fbeidou_section_bg3-1721618089312.png',
          order: 3,
        },
      ],
    },
    {
      id: '143',
      sectionName: '新北斗计划-我们期待怎样的你',
      sections: [
        {
          id: '777823541823',
          title: '超级学霸',
          secondTitle: '相关专业TOP5%学生，基础学科能力扎实',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%96%B0%E5%8C%97%E6%96%97%E8%AE%A1%E5%88%92%2Fbeidou_icon1-1721619298856.png',
          order: 0,
        },
        {
          id: '777823541824',
          title: '学术达人',
          secondTitle: '在国际顶级会议或期刊上发表过重要学术论文，或获得过计算机相关领域专利',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%96%B0%E5%8C%97%E6%96%97%E8%AE%A1%E5%88%92%2Fbeidou_icon2-1721620005122.png',
          order: 1,
        },
        {
          id: '777823541825',
          title: '竞赛大神',
          secondTitle: '国内外顶级大赛（如ACM-ICPC、NOI等）获奖经历',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%96%B0%E5%8C%97%E6%96%97%E8%AE%A1%E5%88%92%2Fbeidou_icon3-1721620051596.png',
          order: 2,
        },
        {
          id: '777823541826',
          title: '工程高手',
          secondTitle: '拥有丰富的项目或实习经验，有将技术运用到实际场景的实践成果',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%96%B0%E5%8C%97%E6%96%97%E8%AE%A1%E5%88%92%2Fbeidou_icon4-1721620124499.png',
          order: 3,
        },
      ],
    },
    {
      id: '144',
      sectionName: '新北斗计划-我们提供哪些职位',
      sections: [
        {
          id: '777823541827',
          title: '大模型技术研究',
          order: 0,
          extra: ['145'],
        },
        {
          id: '777823541828',
          title: '自动驾驶技术研究',
          order: 1,
          extra: ['146'],
        },
        {
          id: '777823541831',
          title: '无人机技术研究',
          order: 2,
          extra: ['149'],
        },
        {
          id: '777823541830',
          title: '运筹优化和智能决策',
          order: 3,
          extra: ['148'],
        },
      ],
    },
    {
      id: '145',
      sectionName: '新北斗计划-我们提供哪些职位-大模型与AIGC',
      sections: [
        {
          id: '777823541832',
          title: '大模型基座技术研究',
          secondTitle: '关注后训练，强化学习，推理能力等，探索多模态预训练新范式',
          order: 0,
        },
        {
          id: '777823541935',
          title: '大模型训练、推理引擎研究',
          secondTitle: '关注大模型在GPU集群训练效率与稳定性、构建高性能推理服务等',
          order: 1,
        },
        {
          id: '777823541936',
          title: '多模态理解与生成研究',
          secondTitle: '关注文本、音频、图像、视频等多个模态的生成技术研究，探索多模态数字人技术等',
          order: 2,
        },
        {
          id: '777823541937',
          title: '大模型应用探索',
          secondTitle: '关注RAG、Agent的研究，持续探索大模型在搜广推等场景的应用等',
          order: 3,
        },
      ],
    },
    {
      id: '150',
      sectionName: '新北斗计划-北斗人物',
      sections: [
        {
          id: '777823541849',
          title: '刘宝旭',
          secondTitle: '-192px;-12px',
          linkUrl:
            'https://mp.weixin.qq.com/s?__biz=MjM5NzYyMzIwMg==&mid=2792231542&idx=3&sn=79b3cdd5f20cb25ffadb0ff6d5d6d225&chksm=854d96bbb23a1fad3055d201338ac710c6cafefac19abf6dac18791ae6facac2db6b41447791&scene=178&',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%96%B0%E5%8C%97%E6%96%97%E8%AE%A1%E5%88%92%2Flbx-1722425065279.png',
          order: 0,
          extra: ['151'],
        },
        {
          id: '777823541918',
          title: '蔡剑成',
          secondTitle: '-6px;-6px',
          linkUrl: 'https://mp.weixin.qq.com/s/-cCMU1Aqdd_VErbrHWZnUA',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%96%B0%E5%8C%97%E6%96%97%E8%AE%A1%E5%88%92%2Fcjc-1722426241289.png',
          order: 1,
          extra: ['152'],
        },
        {
          id: '777823541885',
          title: '石文杰',
          secondTitle: '-470px;-120px',
          linkUrl: 'https://mp.weixin.qq.com/s/IJ6Uu_1IaJlq8yjEHKS0xA',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%96%B0%E5%8C%97%E6%96%97%E8%AE%A1%E5%88%92%2Fswj-1722426627079.png',
          order: 2,
          extra: ['153'],
        },
        {
          id: '777823541886',
          title: '李亚蓓',
          secondTitle: '-60px;-10px',
          linkUrl: 'https://mp.weixin.qq.com/s/-cCMU1Aqdd_VErbrHWZnUA',
          imgUrl:
            '//s3plus.meituan.net/hr-zhaopin-static-files/%E5%AE%98%E7%BD%91%2F%E6%96%B0%E5%8C%97%E6%96%97%E8%AE%A1%E5%88%92%2Flyb-1722426653315.png',
          order: 3,
          extra: ['154'],
        },
      ],
    },
    {
      id: '151',
      sectionName: '新北斗计划-北斗人物-刘宝旭',
      sections: [
        {
          id: '777823541853',
          title: '北京航空航天大学硕士',
          order: 0,
          isNotice: false,
        },
        {
          id: '777823541922',
          title: '无人机团队飞行控制组技术专家',
          order: 1,
          isNotice: false,
        },
        {
          id: '777823541923',
          title: '从校招生起成长为带领团队的技术专家',
          order: 2,
          isNotice: true,
        },
        {
          id: '777823541924',
          title: '从事控制方向的研发落地工作，提升无人机、自动化装备的稳定性、精度和效率',
          order: 3,
          isNotice: false,
        },
      ],
    },
    {
      id: '154',
      sectionName: '新北斗计划-北斗人物-李亚蓓',
      sections: [
        {
          id: '777823541897',
          title: '中国科学院大学博士',
          order: 0,
          isNotice: false,
        },
        {
          id: '777823541898',
          title: '学术达人',
          order: 1,
          isNotice: false,
        },
        {
          id: '777823541933',
          title: '在职期间攻克基于lidar的3D障碍物检测中的大车检测, 多视角融合等难题。',
          order: 2,
          isNotice: false,
        },
      ],
    },
    {
      id: '146',
      sectionName: '新北斗计划-我们提供哪些职位-自动驾驶技术研究',
      sections: [
        {
          id: '777823541904',
          title: '自动驾驶感知算法研究',
          secondTitle: '参与多模态大模型在自动驾驶场景中的适配和优化',
          order: 0,
        },
        {
          id: '777823541905',
          title: '自动驾驶系统研究',
          secondTitle: '探索自动驾驶模型在千卡规模集群的训练能力，在训练优化器、高价值数据获取等基础方向的研究',
          order: 1,
        },
        {
          id: '777823541940',
          title: '自动驾驶决策规划研究',
          secondTitle: '关注多模态端到端自动驾驶算法，交互预测决策模型算法，SFT、Alignment等',
          order: 2,
        },
        {
          id: '777823541941',
          title: '自动驾驶高精地图研究',
          secondTitle: '关注地图的scale up，重点涉及开发静态元素BEV、Occupancy算法、云端数据自动标注等',
          order: 3,
        },
      ],
    },
    {
      id: '147',
      sectionName: '新北斗计划-我们提供哪些职位-视频编解码',
      sections: [
        {
          id: '777823541908',
          title: '视频画质评价算法研究',
          secondTitle: '关注基于深度学习及计算机视觉算法的无参考视频画质评价算法的研究等',
          order: 0,
        },
        {
          id: '777823541943',
          title: '视频画质增强算法研究',
          secondTitle: '关注针对美团直播、短视频场景的画质增强算法研究、视频前处理、后处理阶段画质增强算法的实现等',
          order: 1,
        },
        {
          id: '777823541944',
          title: '视频智能创作算法研究',
          secondTitle: '探索基于美团直播、短视频场景的视频、图片AIGC相关算法的业务场景落地等',
          order: 2,
        },
      ],
    },
    {
      id: '152',
      sectionName: '新北斗计划-北斗人物-蔡剑成',
      sections: [
        {
          id: '777823541925',
          title: '中国科学院大学硕士',
          order: 0,
          isNotice: false,
        },
        {
          id: '777823541892',
          title: '竞赛大神',
          order: 1,
          isNotice: false,
        },
        {
          id: '777823541927',
          title: '负责无人机机载视觉算法研究',
          order: 2,
          isNotice: false,
        },
      ],
    },
    {
      id: '153',
      sectionName: '新北斗计划-北斗人物-石文杰',
      sections: [
        {
          id: '777823541928',
          title: '清华大学博士',
          order: 0,
          isNotice: false,
        },
        {
          id: '777823541895',
          title: '学术达人',
          order: 1,
          isNotice: false,
        },
        {
          id: '777823541896',
          title: '负责解决自动车的快速定位问题，让自动车成为了懂得礼让、能灵活绕道的“配送小能手”',
          order: 2,
          isNotice: false,
        },
      ],
    },
    {
      id: '148',
      sectionName: '新北斗计划-我们提供哪些职位-运筹优化和智能调度',
      sections: [
        {
          id: '777823541945',
          title: '智能决策算法研究',
          secondTitle: '依托全球领先的超大规模及时配送网络，研究万人万单的只能调度等前沿决策模型和算法',
          order: 0,
        },
      ],
    },
    {
      id: '158',
      sectionName: '事业部-食杂零售',
      sections: [
        {
          id: '777823541965',
          title: '美团优选',
          description:
            '<p>美团优选，作为美团旗下的社区电商业务<strong>。</strong>2022年10月，美团优选正式将品牌定位升级为“明日达超市”，并推出全新的品牌口号“真的真的省”。美团优选采取“今日下单+次日自提”的模式，为社区家庭用户精选高性价比的蔬果、肉禽蛋、乳制品、酒水饮料、家居厨卫等品类商品。我们通过覆盖城乡的自提点网络，为消费者提供高性价比的商品和服务，满足消费者对省和便利的需求。</p><p>美团优选也始终致力于实现社会价值，自2020年底，我们推出“农鲜直采”计划，加大优质农产品源头直采的力度，加速优质农产品从原产地直达社区，通过科技创新助力改善农产品生产、分配、流通、消费各环节，并推动需求牵引供给、供给创造需求的更好动态平衡，让城乡居民受益的同时也让农民实现增收。</p>',
          order: 0,
          code: '001',
        },
        {
          id: '777823541966',
          title: '小象超市',
          description:
            '<p>小象超市为美团自营零售业务，定位为社区居民的“30分钟快送超市”，采用“手机App+线下服务站”的模式，通过在社区设立的集存储、分拣、配送为一体的便民服务站，为社区居民提供生鲜食杂日用及配送服务。</p><p>目前，小象超市已在北京、上海、深圳、广州、武汉、苏州、杭州等多个城市上线。</p><p>在美团“零售+科技”战略聚焦下，小象超市承载着“深耕即时零售，提升消费体验”的任务，是公司在线上零售探索的核心业态之一，给一二线城市用户带来线上零售即时达的消费体验，解决城市家庭追求快速、品质服务的需求。</p><p>在这里，我们有来自国内外知名零售公司的大牛和一群热爱零售，胸怀使命，心系民生的伙伴，小象超市欢迎你的加入！</p>',
          order: 1,
          code: '002',
        },
        {
          id: '777823541967',
          title: '快驴进货',
          description:
            '<p>快驴进货是美团旗下的餐饮供应链平台，帮助餐饮商户以更低成本、更高效率来获取安全可靠的食材供应，让餐饮采购更简单。快驴进货同步发展“自营+平台”的业务模式，在采购环节一方面向上游供应商直采大宗商品，另一方面引入各地批发商，助力平台伙伴共同发展；在销售环节既有自建团队进行市场、客户拓展，又帮助各地批发商拓展业务；同时自建仓储管理系统、配送网络与团队，为客户提供优质履约服务。</p><p>截至2022年，快驴进货布局了全国41个城市，为百万家商户提供“全、省、稳、好”的餐饮供应链服务。我们拥有3000+品牌食材、超5万SKU商品、超28万商品资质，并提供源头严审核、食品安全严把关、24小时无忧售后的全面保障，实现手机下单、送货上门的高效采购模式，帮百万商家节省了采购时间与成本，助力平台伙伴共同发展，共享机遇。</p><p>在这里，你将收获完善的员工发展机制及学习体系，与各界专家一起深度参与餐饮供应链业务的发展。欢迎优秀的你加入美团快驴进货，与我们一起成长，一起更好！</p>',
          order: 2,
          code: '003',
        },
      ],
    },
    {
      id: '159',
      sectionName: '事业部-软硬件服务',
      sections: [
        {
          id: '777823541968',
          title: '美团餐饮系统（SaaS）',
          description:
            '<p>美团餐饮系统（SaaS）为餐饮商户提供餐厅数字化解决方案，帮餐厅实现从前厅管理、后厨生产管理、会员管理、外卖管理、线上运营管理到供应链管理的数字化经营，助力于新店推广、效率提升、降低成本、会员营销、流量扶持、智慧选址等六大能力的提升。</p><p>美团餐饮系统打通线上线下顾客数据，帮餐饮商户更了解顾客、商圈，有助于做商业决策，并给顾客带来更好的消费体验。</p><p>我们的团队汇集了餐饮和SaaS领域的优秀人才，秉持着“以客户为中心”和“长期有耐心”的初心，求真、敬畏、敢于自我否定、善于快速学习，欢迎愿意长期致力于餐饮产业数字化、智能化的你加入我们，用科技连接消费者和商家，帮大家吃得更好，生活更好！</p>',
          order: 0,
          code: '001',
        },
        {
          id: '777823541969',
          title: '美团骑行',
          description:
            '<p>美团骑行在全国各个城市开展美团单车、电单车业务，提供绿色、便捷的共享出行服务，是美团出行板块重要的组成部分。我们力求为城市可持续发展提供低碳智能的解决方案，通过技术创新和硬件升级，不断优化全流程骑行体验，为低碳出行提供更好的服务。其中，美团单车旨在为城市居民提供通勤接驳服务，满足用户短途接驳出行需求；美团电单车则满足用户中短途多场景低碳出行需求。 </p><p>我们有开放的工作氛围，也有充满韧劲和创造力，心系低碳出行的伙伴。加入我们，一起为用户创造更好的出行体验。</p>',
          order: 1,
          code: '002',
        },
        {
          id: '777823541970',
          title: '美团充电宝',
          description:
            '<p>美团充电宝于2020年正式启动，是服务零售中的共享租赁业务，承接美团使命，致力让大家充电更简单。</p><p>美团充电宝以应急充电功能为服务核心，覆盖吃喝玩乐生活全场景，目前已在全国超过2000多个城市的餐饮、娱乐、机场、地铁、火车站、医院、学校、景区等公共区域及场所提供充电服务，铺设机柜超过200万，有KA、直营、渠道合作商多种业务模式，随时随地保障消费者的充电需求。</p><p>我们的业务资产数量多、场景多元化，追求精益管理。我们的团队大咖云集，崇尚自主驱动，求真务实。我们正处在快速发展期，规模持续增长，目标是市场规模和利润水平双第一。我们的管理者关注团队每个成员的成长，为每个人提供适合自身发展的机会。<br>广阔天地、大有作为，美团充电宝期待你的加入！</p>',
          order: 2,
          code: '003',
        },
      ],
    },
    {
      id: '118',
      sectionName: '校招行程-招聘对象',
      sections: [
        {
          id: '540801325052',
          title: '2026届转正实习',
          secondTitle: '2025年11月~2026年10月',
          order: 0,
        },
        {
          id: '777823541733',
          title: '2025届应届招聘',
          secondTitle: '2024年11月~2025年10月',
          order: 1,
        },
      ],
    },
    {
      id: '86',
      sectionName: '社招问题-全流程',
      sections: [
        {
          id: '777823541651',
          icon: 'NULL',
          title: '美团的社招招聘流程是什么？',
          description:
            '<p>通常来说，是投递岗位→进行面试→offer沟通→背景调查→办理入职。面试环节会分为初试、复试、HR面等，特定岗位还会其他的面试类型，详情可以在面试邀约时咨询与你联系的HR。</p>',
          linkUrl: '/',
          order: 1,
          isNotice: true,
        },
      ],
    },
    {
      id: '149',
      sectionName: '新北斗计划-我们提供哪些职位-无人机技术研究',
      sections: [
        {
          id: '777823541947',
          title: '无人机规划调度算法研究',
          secondTitle: '关注多无人机/多智能体规划调度、自主决策规划等',
          order: 1,
        },
        {
          id: '777823541948',
          title: '无人机分布式系统研发',
          secondTitle: '探索无人机云边端分布式系统设计和关键模块开发，如无人机空中交管、导航定位、智能监看等',
          order: 2,
        },
        {
          id: '777823541949',
          title: '无人机系统软件研发',
          secondTitle: '参与无人机及相关硬件产品线的设备端软件架构设计等',
          order: 3,
        },
        {
          id: '777823541950',
          title: '无人机飞行器总体设计',
          secondTitle: '涉及飞行器总体构型设计与分析、飞行动力学建模等',
          order: 4,
        },
        {
          id: '777823541958',
          title: '机器人技术研究',
          secondTitle: '关注机器人算法、硬件开发的关键技术',
          order: 4,
        },
      ],
    },
  ],
};

export default cmsBackup;
